import { FilterFn } from '@tanstack/react-table';

export const contains: FilterFn<any> = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value == null) return false;
  
  const searchValue = String(filterValue).toLowerCase();
  const cellValue = String(value).toLowerCase();
  
  return cellValue.includes(searchValue);
};

export const startsWith: FilterFn<any> = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value == null) return false;
  
  const searchValue = String(filterValue).toLowerCase();
  const cellValue = String(value).toLowerCase();
  
  return cellValue.startsWith(searchValue);
};

export const endsWith: FilterFn<any> = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value == null) return false;
  
  const searchValue = String(filterValue).toLowerCase();
  const cellValue = String(value).toLowerCase();
  
  return cellValue.endsWith(searchValue);
};

export const equals: FilterFn<any> = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value == null && filterValue == null) return true;
  if (value == null || filterValue == null) return false;
  
  const searchValue = String(filterValue).toLowerCase();
  const cellValue = String(value).toLowerCase();
  
  return cellValue === searchValue;
};

export const notEquals: FilterFn<any> = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (value == null && filterValue == null) return false;
  if (value == null || filterValue == null) return true;
  
  const searchValue = String(filterValue).toLowerCase();
  const cellValue = String(value).toLowerCase();
  
  return cellValue !== searchValue;
};

export const isEmpty: FilterFn<any> = (row, columnId) => {
  const value = row.getValue(columnId);
  return value == null || String(value).trim() === '';
};

export const isNotEmpty: FilterFn<any> = (row, columnId) => {
  const value = row.getValue(columnId);
  return value != null && String(value).trim() !== '';
};

export const multiSelect: FilterFn<any> = (row, columnId, filterValue: string[]) => {
  const value = row.getValue(columnId);
  
  if (!Array.isArray(filterValue)) {
    return true;
  }
  
  if (filterValue.length === 0) {
    return false;
  }
  
  const cellValue = value == null || String(value).trim() === '' ? '(Blank)' : String(value);
  
  return filterValue.includes(cellValue);
};